<div class="content container-fluid">
  <div class="row">
    <div class="col-9">
      <app-game-navigation [game]="game"></app-game-navigation>

      <div class="loading" *ngIf="!homePlayers">
        <img src="assets/loading.svg" alt="loading" />
        <h3>Loading events...</h3>
      </div>

      <mat-tab-group mat-stretch-tabs (selectedTabChange)="changeTab($event)">
        <mat-tab [label]="game.homeTeam">
          <div class="team" *ngIf="homePlayers" style="margin-top: 16px">
            <mat-slide-toggle
              color="primary"
              [(ngModel)]="strictPositions[0]"
              title="Replace player on same position. e.g. Left defender for left defender."
              >Strict positions</mat-slide-toggle
            >

            <button
              mat-icon-button
              (click)="toggleLineupLock()"
              [title]="isSwapPlayersLocked ? 'Unlock player swapping' : 'Lock player swapping'"
              class="lineup-lock-button"
            >
              <mat-icon>{{ isSwapPlayersLocked ? 'lock' : 'lock_open' }}</mat-icon>
            </button>

            <app-warning
              *ngIf="homeWarnings"
              [messages]="homeWarnings"
            ></app-warning>

            <div class="row no-gutters" *ngFor="let line of numberOfLines">
              <div class="line" (click)="toggleDefenseLine(line, game.homeTeam)"
                >{{ line }}D</div
              >
              <div class="col-4">
                <div class="row no-gutters">
                  <div
                    *ngFor="
                      let player of homePlayers.defenders[line];
                      let i = index;
                      let odd = odd;
                      let even = even
                    "
                    [id]="positionKey('H', line, 'D', i)"
                    cdkDropList
                    [cdkDropListData]="{
                      targetPlayerPositionKey: positionKey('H', line, 'D', i),
                      targetPlayerIndex: i,
                      targetPlayerLine: homePlayers.defenders[line]
                    }"
                    [cdkDropListConnectedTo]="
                      connectedDropLists(
                        'H',
                        positionKey('H', line, 'D', i),
                        homePlayers
                      )
                    "
                    cdkDropListSortingDisabled
                    (cdkDropListDropped)="drop($event)"
                    class="col-6"
                    [class]="dragInProgress ? 'drag-in-progress' : ''"
                  >
                    <app-player-button
                      cdkDrag
                      [cdkDragDisabled]="isSwapPlayersLocked || !player.playerNumber"
                      [cdkDragData]="{
                        sourcePlayerPositionKey: positionKey('H', line, 'D', i),
                        sourcePlayerIndex: i,
                        sourcePlayerLine: homePlayers.defenders[line]
                      }"
                      (cdkDragStarted)="dragStart()"
                      (cdkDragEnded)="dragEnd()"
                      [player]="player"
                      [shift]="activeShifts[player.playerNumber]"
                      [selected]="player.playerNumber === selectedPlayerNumber"
                      [ngClass]="{ odd: odd, even: even }"
                      [disabled]="!player?.playerId"
                      (toggle)="player?.playerId && togglePlayer($event)"
                    >
                    </app-player-button>
                  </div>
                </div>
              </div>

              <div class="line" (click)="toggleForwardLine(line, game.homeTeam)"
                >{{ line }}F</div
              >
              <div class="col-6">
                <div class="row no-gutters">
                  <div
                    *ngFor="
                      let player of homePlayers.forwards[line];
                      let i = index;
                      let odd = odd;
                      let even = even
                    "
                    [id]="positionKey('H', line, 'F', i)"
                    cdkDropList
                    [cdkDropListData]="{
                      targetPlayerPositionKey: positionKey('H', line, 'F', i),
                      targetPlayerIndex: i,
                      targetPlayerLine: homePlayers.forwards[line]
                    }"
                    [cdkDropListConnectedTo]="
                      connectedDropLists(
                        'H',
                        positionKey('H', line, 'F', i),
                        homePlayers
                      )
                    "
                    cdkDropListSortingDisabled
                    (cdkDropListDropped)="drop($event)"
                    class="col-4"
                    [class]="dragInProgress ? 'drag-in-progress' : ''"
                  >
                    <app-player-button
                      cdkDrag
                      [cdkDragDisabled]="isSwapPlayersLocked || !player.playerNumber"
                      [cdkDragData]="{
                        sourcePlayerPositionKey: positionKey('H', line, 'F', i),
                        sourcePlayerIndex: i,
                        sourcePlayerLine: homePlayers.forwards[line]
                      }"
                      (cdkDragStarted)="dragStart()"
                      (cdkDragEnded)="dragEnd()"
                      [player]="player"
                      [shift]="activeShifts[player.playerNumber]"
                      [selected]="player.playerNumber === selectedPlayerNumber"
                      [ngClass]="{ odd: odd, even: even }"
                      (toggle)="player?.playerId && togglePlayer($event)"
                    >
                    </app-player-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="line">GK</div>
              <div class="col-11">
                <div class="row no-gutters">
                  <div
                    *ngFor="
                      let player of homePlayers.goalkeepers;
                      let i = index
                    "
                    [id]="positionKey('H', undefined, 'G', i)"
                    cdkDropList
                    [cdkDropListData]="{
                      targetPlayerPositionKey: positionKey(
                        'H',
                        undefined,
                        'G',
                        i
                      ),
                      targetPlayerIndex: i,
                      targetPlayerLine: homePlayers.goalkeepers
                    }"
                    [cdkDropListConnectedTo]="
                      connectedDropLists(
                        'H',
                        positionKey('H', undefined, 'G', i),
                        homePlayers
                      )
                    "
                    cdkDropListSortingDisabled
                    (cdkDropListDropped)="drop($event)"
                    class="col-2"
                    [class]="dragInProgress ? 'drag-in-progress' : ''"
                  >
                    <app-player-button
                      cdkDrag
                      [cdkDragDisabled]="isSwapPlayersLocked || !player.playerNumber"
                      [cdkDragData]="{
                        sourcePlayerPositionKey: positionKey(
                          'H',
                          undefined,
                          'G',
                          i
                        ),
                        sourcePlayerIndex: i,
                        sourcePlayerLine: homePlayers.goalkeepers
                      }"
                      (cdkDragStarted)="dragStart()"
                      (cdkDragEnded)="dragEnd()"
                      [player]="player"
                      [shift]="activeShifts[player.playerNumber]"
                      [selected]="player.playerNumber === selectedPlayerNumber"
                      (toggle)="player?.playerId && togglePlayer($event)"
                    >
                    </app-player-button>
                  </div> </div
              ></div>
            </div>
          </div>
        </mat-tab>

        <mat-tab [label]="game.awayTeam">
          <div class="team" *ngIf="awayPlayers" style="margin-top: 16px">
            <mat-slide-toggle
              color="primary"
              [(ngModel)]="strictPositions[1]"
              title="Replace player on same position. e.g. Left defender for left defender."
              >Strict positions</mat-slide-toggle
            >

            <button
              mat-icon-button
              (click)="toggleLineupLock()"
              [title]="isSwapPlayersLocked ? 'Unlock lineup editing' : 'Lock lineup editing'"
              class="lineup-lock-button"
            >
              <mat-icon>{{ isSwapPlayersLocked ? 'lock' : 'lock_open' }}</mat-icon>
            </button>

            <app-warning
              *ngIf="awayWarnings"
              [messages]="awayWarnings"
            ></app-warning>

            <div class="row no-gutters" *ngFor="let line of numberOfLines">
              <div class="line" (click)="toggleDefenseLine(line, game.awayTeam)"
                >{{ line }}D</div
              >
              <div class="col-4">
                <div class="row no-gutters">
                  <div
                    *ngFor="
                      let player of awayPlayers.defenders[line];
                      let i = index;
                      let odd = odd;
                      let even = even
                    "
                    [id]="positionKey('A', line, 'D', i)"
                    cdkDropList
                    [cdkDropListData]="{
                      targetPlayerPositionKey: positionKey('A', line, 'D', i),
                      targetPlayerIndex: i,
                      targetPlayerLine: awayPlayers.defenders[line]
                    }"
                    [cdkDropListConnectedTo]="
                      connectedDropLists(
                        'A',
                        positionKey('A', line, 'D', i),
                        awayPlayers
                      )
                    "
                    cdkDropListSortingDisabled
                    (cdkDropListDropped)="drop($event)"
                    class="col-6"
                    [class]="dragInProgress ? 'drag-in-progress' : ''"
                  >
                    <app-player-button
                      cdkDrag
                      [cdkDragDisabled]="isSwapPlayersLocked || !player.playerNumber"
                      [cdkDragData]="{
                        sourcePlayerPositionKey: positionKey('A', line, 'D', i),
                        sourcePlayerIndex: i,
                        sourcePlayerLine: awayPlayers.defenders[line]
                      }"
                      (cdkDragStarted)="dragStart()"
                      (cdkDragEnded)="dragEnd()"
                      [player]="player"
                      [shift]="activeShifts[player.playerNumber]"
                      [selected]="player.playerNumber === selectedPlayerNumber"
                      [ngClass]="{ odd: odd, even: even }"
                      (toggle)="player?.playerId && togglePlayer($event)"
                    >
                    </app-player-button>
                  </div>
                </div>
              </div>

              <div class="line" (click)="toggleForwardLine(line, game.awayTeam)"
                >{{ line }}F</div
              >
              <div class="col-6">
                <div class="row no-gutters">
                  <div
                    *ngFor="
                      let player of awayPlayers.forwards[line];
                      let i = index;
                      let odd = odd;
                      let even = even
                    "
                    [id]="positionKey('A', line, 'F', i)"
                    cdkDropList
                    [cdkDropListData]="{
                      targetPlayerPositionKey: positionKey('A', line, 'F', i),
                      targetPlayerIndex: i,
                      targetPlayerLine: awayPlayers.forwards[line]
                    }"
                    [cdkDropListConnectedTo]="
                      connectedDropLists(
                        'A',
                        positionKey('A', line, 'F', i),
                        awayPlayers
                      )
                    "
                    cdkDropListSortingDisabled
                    (cdkDropListDropped)="drop($event)"
                    class="col-4"
                    [class]="dragInProgress ? 'drag-in-progress' : ''"
                  >
                    <app-player-button
                      cdkDrag
                      [cdkDragDisabled]="isSwapPlayersLocked || !player.playerNumber"
                      [cdkDragData]="{
                        sourcePlayerPositionKey: positionKey('A', line, 'F', i),
                        sourcePlayerIndex: i,
                        sourcePlayerLine: awayPlayers.forwards[line]
                      }"
                      (cdkDragStarted)="dragStart()"
                      (cdkDragEnded)="dragEnd()"
                      [player]="player"
                      [shift]="activeShifts[player.playerNumber]"
                      [selected]="player.playerNumber === selectedPlayerNumber"
                      [ngClass]="{ odd: odd, even: even }"
                      (toggle)="player?.playerId && togglePlayer($event)"
                    >
                    </app-player-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="line">GK</div>
              <div class="col-11">
                <div class="row no-gutters">
                  <div
                    *ngFor="
                      let player of awayPlayers.goalkeepers;
                      let i = index
                    "
                    [id]="positionKey('A', undefined, 'G', i)"
                    cdkDropList
                    [cdkDropListData]="{
                      targetPlayerPositionKey: positionKey(
                        'A',
                        undefined,
                        'G',
                        i
                      ),
                      targetPlayerIndex: i,
                      targetPlayerLine: awayPlayers.goalkeepers
                    }"
                    [cdkDropListConnectedTo]="
                      connectedDropLists(
                        'A',
                        positionKey('A', undefined, 'G', i),
                        awayPlayers
                      )
                    "
                    cdkDropListSortingDisabled
                    (cdkDropListDropped)="drop($event)"
                    class="col-2"
                    [class]="dragInProgress ? 'drag-in-progress' : ''"
                  >
                    <app-player-button
                      cdkDrag
                      [cdkDragDisabled]="isSwapPlayersLocked || !player.playerNumber"
                      [cdkDragData]="{
                        sourcePlayerPositionKey: positionKey(
                          'A',
                          undefined,
                          'G',
                          i
                        ),
                        sourcePlayerIndex: i,
                        sourcePlayerLine: awayPlayers.goalkeepers
                      }"
                      (cdkDragStarted)="dragStart()"
                      (cdkDragEnded)="dragEnd()"
                      [player]="player"
                      [shift]="activeShifts[player.playerNumber]"
                      [selected]="player.playerNumber === selectedPlayerNumber"
                      (toggle)="togglePlayer($event)"
                    >
                    </app-player-button>
                  </div> </div
              ></div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="col-3 right">
      Video Time:
      <span class="video-time">{{ videoTime * 10 | timecode }}</span>

      <hr />

      <mat-select
        id="homeTeamEmptyNet"
        class="empty-net"
        [(ngModel)]="isHomeTeamEmptyNet"
        (valueChange)="emptyNetChanged(game.homeTeam)"
        placeholder="Home Empty Net"
        [disabled]="playing"
      >
        <mat-option [value]="false">Home Empty Net: No</mat-option>
        <mat-option [value]="true">Home Empty Net: Yes</mat-option>
      </mat-select>

      <mat-select
        id="awayTeamEmptyNet"
        class="empty-net"
        [(ngModel)]="isAwayTeamEmptyNet"
        (valueChange)="emptyNetChanged(game.awayTeam)"
        placeholder="Away Empty Net"
        [disabled]="playing"
      >
        <mat-option [value]="false">Away Empty Net: No</mat-option>
        <mat-option [value]="true">Away Empty Net: Yes</mat-option>
      </mat-select>

      <hr />

      <div style="display: flex">
        <mat-select
          id="period"
          class="period"
          [(ngModel)]="period"
          placeholder="Period"
          [disabled]="playing"
          (valueChange)="periodChanged($event)"
          style="margin-right: 10px"
        >
          <mat-option value="1">P1</mat-option>
          <mat-option value="2">P2</mat-option>
          <mat-option value="3">P3</mat-option>
          <mat-option value="4">P4</mat-option>
          <mat-option value="5">P5</mat-option>
          <mat-option value="6">P6</mat-option>
          <mat-option value="7">P7</mat-option>
        </mat-select>

        <app-game-clock style="margin-right: 10px"></app-game-clock>
        <app-strength-state></app-strength-state>
      </div>

      <hr />

      <app-events-overview
        [game]="game"
        [eventType]="'time_on_ice'"
        [events]="events"
        (seek)="seekEvent($event)"
        (delete)="deleteEvent($event)"
      >
      </app-events-overview>
    </div>
  </div>
</div>
